import React, { useContext, useMemo } from "react";
import { Refresh } from "@material-ui/icons";
import { IconButton, Tooltip } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { loadAnalytics } from "../../redux/actions";
import { HistoryContext } from "../../redux/historyContext";
import { searchStringToParams } from "../../utils/urlHelper";
export const RefreshButton = () => {
    const dispatch = useDispatch();
    const { location } = useContext(HistoryContext);
    const { search } = location;
    const searchParams = useMemo(() => searchStringToParams(search), [search]);
    const handleRefresh = () => {
        dispatch(loadAnalytics(searchParams));
    };
    return (React.createElement("span", null,
        React.createElement(Tooltip, { title: "Refresh dashboard" },
            React.createElement(IconButton, { size: "medium", onClick: handleRefresh, "data-test": "refresh-dashboard", "aria-controls": "dashboard-filter", color: "primary" },
                React.createElement(Refresh, null)))));
};
